<template>
  <b-modal
    id="modal-lengkapi-profil"
    modal-class="modal-dark"
    size="lg"
    body-class="p-2"
    static
    hide-footer
    hide-header
    centered
    no-close-on-backdrop
    no-close-on-esc
  >
    <validation-observer
      v-if="!successUpdateBusiness"
      ref="formBusiness"
      #default="{ invalid, pristine }"
    >
      <b-form>

        <h3 class="text-black mb-2">
          <strong>{{ title }}</strong>
        </h3>

        <div class="mt-1">
          <div>

            <b-form-group
              label-cols-md="3"
              class="ml-0"
            >
              <template #label>
                <span class="text-black">
                  Upload Logo
                </span>
              </template>
              <transition name="fade">
                <b-avatar
                  v-model="imageFile"
                  variant="light-primary"
                  size="50"
                  :src="imageFile ? fileUrl(imageFile) : null"
                  class="mr-50"
                />
              </transition>
              <label
                v-if="imageFile === null"
                for="uploadLogo"
              >
                <b-avatar
                  variant="light-dark"
                  size="50"
                  class="btn btn-flat-primary btn-icon"
                >
                  <feather-icon
                    icon="PlusIcon"
                    size="35"
                  />
                </b-avatar>
              </label>
              <label
                v-else
                for="uploadLogo"
                class="btn btn-flat-dark btn-icon"
              >
                <feather-icon
                  icon="EditIcon"
                  size="20"
                />
              </label>
              <label
                v-if="imageFile !== null"
                class="btn btn-flat-primary btn-icon"
                @click="removeLogoBusiness"
              >
                <feather-icon
                  icon="Trash2Icon"
                  size="20"
                />
              </label>
              <b-form-file
                id="uploadLogo"
                v-model="imageFile"
                placeholder="Pilih atau drop file disini..."
                drop-placeholder="Drop file disini..."
                accept="image/*"
                class="d-none"
              />
            </b-form-group>

            <b-form-group
              label-cols-md="3"
              class="ml-0"
            >
              <template #label>
                <div style="display:grid;">
                  <span class="text-black">
                    Nama Bisnis<span class="text-primary">*</span>
                  </span>
                  <span>
                    Akan ditampilkan di Label
                  </span>
                </div>
              </template>
              <validation-provider
                #default="{errors}"
                name="Nama Bisnis"
                rules="required"
              >
                <b-form-input
                  v-model="nameBusiness"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Nama Bisnis"
                  :formatter="formatBusinessName"
                  @keypress="validateInputBusinessName"
                />
                <b-row class="justify-content-between">
                  <small class="text-primary ml-1 mt-50">{{ errors[0] }}</small>
                  <small class="mr-1 mt-50">
                    <small
                      v-if="messageErrorLengthNameBusiness"
                      class="text-primary"
                    >
                      *hindari menggunakan simbol (/) (=) (:) (;)
                    </small>
                    {{ nameBusiness.length }}/30
                  </small>
                </b-row>
              </validation-provider>
            </b-form-group>

            <b-form-group
              label-cols-md="3"
              class="ml-0"
            >
              <template #label>
                <div style="display:grid;">
                  <span class="text-black">
                    No HP Bisnis<span class="text-primary">*</span>
                  </span>
                  <span>
                    Akan ditampilkan di Label
                  </span>
                </div>
              </template>
              <validation-provider
                #default="{errors}"
                name="No HP Bisnis"
                rules="required"
              >
                <b-form-input
                  v-model="phoneBusiness"
                  :state="errors.length > 0 ? false:null"
                  placeholder="No HP Bisnis"
                  type="number"
                  @input="formatPhoneProfile"
                  @keypress="validateInputPhoneProfile"
                  @keydown="handleArrowInput"
                />
                <b-row class="justify-content-between">
                  <small class="text-primary ml-1 mt-50">{{ errors[0] }}</small>
                  <small class="mr-1 mt-50">
                    <small
                      v-if="messageErrorPhone"
                      class="text-primary"
                    >
                      *minimal 9 digit dan hanya berupa angka.
                    </small>
                  </small>
                </b-row>
              </validation-provider>
            </b-form-group>

            <b-form-group
              label="Lokasi"
              label-cols-md="3"
              class="ml-0"
            >
              <template #label>
                <span class="text-black">
                  Lokasi<span class="text-primary">*</span>
                </span>
              </template>
              <validation-provider
                #default="{errors}"
                name="Lokasi"
                rules="required"
              >
                <infinite-select
                  v-model="bussinessLocation"
                  class="w-100"
                  placeholder="Input Lokasi Bisnis"
                  option-label="values"
                  :options="useFetcherLocations.data"
                  :loading="useFetcherLocations.isLoading"
                  :has-next-page="useFetcherLocations.hasMore"
                  :debounce-timeout="500"
                  @input="handleValueCityCode"
                  @on-search="onSearchProvince"
                  @on-intersect="useFetcherLocations.fetchData"
                ><template #no-options="{ search, searching }">
                  <template v-if="searching">
                    Lokasi untuk <em>'{{ search }}'</em> tidak ditemukan.
                  </template>
                  <em v-else>Masukan lokasi yang valid</em>
                </template>
                </infinite-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group
              label-cols-md="3"
              class="ml-0"
            >
              <template #label>
                <span class="text-black">
                  Sektor Bisnis
                </span>
              </template>
              <v-select
                v-model="sektorBusiness"
                label="partner_category_name"
                :options="partnerCategoryItems"
                :reduce="option => option.partner_category_name"
              />
            </b-form-group>

            <b-form-group
              label-cols-md="3"
              class="ml-0"
            >
              <template #label>
                <span class="text-black">
                  Tipe Bisnis
                </span>
              </template>
              <v-select
                v-model="typeBusiness"
                label="name"
                :options="businessTypeItems"
                :reduce="option => option.id"
              />
            </b-form-group>

          </div>

          <b-col
            class="d-flex justify-content-end mt-3 p-0 gap-3"
            md="12"
          >
            <b-button
              type="submit"
              :variant="loadingSubmitBusiness || invalid || pristine ? 'secondary' : 'primary'"
              :disabled="loadingSubmitBusiness || invalid || pristine"
              @click.prevent="updateBusiness"
            >
              <b-spinner
                v-if="loadingSubmitBusiness"
                variant="light"
                small
              />
              Simpan
            </b-button>
          </b-col>
        </div>
      </b-form>
    </validation-observer>
    <div
      v-else
      class="text-center font-[#000]"
    >
      <img
        src="https://storage.googleapis.com/komerce/core/icon-success-verified.svg"
        alt="Komerce"
      >
      <h3 class="success-title">
        Berhasil!</h3>
      <p class="success-description">
        Data profile bisnis berhasil tersimpan.</p>
      <p>Menutup dalam {{ countDown }} detik</p>
    </div>
  </b-modal>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import VSelect from 'vue-select'
import InfiniteSelect from '@/views/components/select/InfiniteSelect.vue'
import { createPaginatedFetcher } from '@/@core/libs/fetch/usePaginatedFetcher'
import { startCountdown } from '@/@core/utils/countdown'
import { mapState } from 'vuex'
import { getUserData, updateProfileKompack } from '@/@core/utils/kompack/checker'

/**
 * Komponen modal untuk melengkapi informasi profil bisnis
 * @component ModalLengkapiProfil
 * @description Modal dialog yang memungkinkan pengguna melengkapi profil bisnis mereka
 * termasuk nama bisnis, telepon, lokasi, sektor, tipe, dan upload logo
 */
export default {
  name: 'ModalLengkapiProfil',
  components: {
    ValidationObserver,
    ValidationProvider,
    VSelect,
    InfiniteSelect,
  },
  props: {
    title: {
      type: String,
      default: 'Lengkapi Profil',
    },
  },
  data() {
    return {
      successUpdateBusiness: false,
      userId: getUserData().id,
      name: '',
      imageFile: null,
      imageInitialFile: null,
      fieldLogoBusiness: '',
      nameBusiness: '',
      phoneBusiness: '',
      bussinessLocation: null,
      sektorBusiness: '',
      cityCode: null,
      typeBusiness: '',
      initialLocations: [],
      partnerCategoryItems: [],
      businessTypeItems: [],
      messageErrorLengthNameBusiness: false,
      messageErrorPhone: false,
      loadingSubmitBusiness: false,
      useFetcherLocations: createPaginatedFetcher(this.fetchProvince),
      required,
      countDown: 4,
    }
  },
  computed: {
    ...mapState('dashboard', ['profile']),
  },
  mounted() {
    this.loadPartnerCategory()
    this.loadBusinessType()
    this.useFetcherLocations.fetchData()
  },
  methods: {
    /**
     * Membuat URL untuk preview file
     * @param {File} file - Objek file untuk dibuat URL-nya
     * @returns {string|null} Object URL untuk file atau null jika tidak ada file
     */
    fileUrl: file => (file ? URL.createObjectURL(file) : null),

    /**
     * Memformat input nama bisnis maksimal 30 karakter
     * @param {string} e - Nilai input yang akan diformat
     * @returns {string} String yang diformat dengan maksimal 30 karakter
     */
    formatBusinessName(e) {
      return String(e).substring(0, 30)
    },

    /**
     * Memvalidasi input nama bisnis untuk mencegah karakter khusus tertentu
     * @param {KeyboardEvent} e - Event keyboard dari input
     */
    validateInputBusinessName(e) {
      if (e.keyCode === 47 || e.keyCode === 61 || e.keyCode === 58 || e.keyCode === 59 || e.keyCode === 13) {
        e.preventDefault()
        this.messageErrorLengthNameBusiness = true
      } else {
        this.messageErrorLengthNameBusiness = false
      }
    },

    /**
     * Memformat dan memvalidasi input nomor telepon
     * @param {Event} e - Event input dari field telepon
     */
    formatPhoneProfile(e) {
      if (e.keyCode === 13) {
        e.preventDefault()
      }
      if (this.phoneBusiness.length < 9) {
        this.messageErrorPhone = true
      } else {
        this.messageErrorPhone = false
      }
    },

    /**
     * Memvalidasi input nomor telepon hanya boleh angka dan minimal panjang
     * @param {KeyboardEvent} e - Event keyboard dari input telepon
     */
    validateInputPhoneProfile(e) {
      if (e.keyCode === 46 || e.keyCode === 45 || e.keyCode === 43 || e.keyCode === 101 || e.keyCode === 44 || e.keyCode === 13) {
        e.preventDefault()
      }
      if (this.phoneBusiness.length < 9) {
        this.messageErrorPhone = true
      } else {
        this.messageErrorPhone = false
      }
    },

    /**
     * Mencegah input arrow key pada field angka
     * @param {KeyboardEvent} e - Event keyboard dari input
     */
    handleArrowInput(e) {
      if (e.which === 38 || e.which === 40) {
        e.preventDefault()
      }
    },

    /**
     * Menangani pemilihan lokasi dan mengekstrak kode kota
     * @param {Object} loc - Objek lokasi yang mengandung city_code
     */
    handleValueCityCode(loc) {
      this.cityCode = loc?.city_code || null
    },

    /**
     * Memicu pencarian untuk provinsi/lokasi
     * @param {string} search - Query string pencarian
     */
    onSearchProvince(search) {
      const keyword = search?.trim() || ''
      const currentSearch = this.useFetcherLocations.options?.search || ''
      if (keyword === currentSearch && this.useFetcherLocations.data.length > 0) {
        return
      }
      this.useFetcherLocations.fetchData({
        reset: true,
        options: keyword ? { search: keyword } : {},
      })
    },

    /**
     * Memuat opsi kategori partner dari API
     * @returns {Promise} Promise yang resolve ketika kategori partner dimuat
     */
    loadPartnerCategory() {
      this.$http_komtim.get('/v1/business_sectors/resource?status=true').then(({ data: { data: partnerCategoryItems } }) => {
        this.partnerCategoryItems = partnerCategoryItems || []
      }).catch(() => {
        this.$toast_error('Gagal load data, silahkan coba lagi', 2000)
      })
    },

    /**
     * Memuat opsi tipe bisnis dari API
     * @returns {Promise} Promise yang resolve ketika tipe bisnis dimuat
     */
    loadBusinessType() {
      this.$http_komtim.get('/v1/business_types/resource?status=true').then(({ data: { data: businessTypeItems } }) => {
        this.businessTypeItems = businessTypeItems || []
      }).catch(() => {
        this.$toast_error('Gagal load data, silahkan coba lagi', 2000)
      })
    },

    /**
     * Menghapus logo bisnis yang dipilih
     */
    removeLogoBusiness() {
      this.imageFile = null
    },

    /**
     * Mengambil data wilayah (kecamatan, kabupaten/kota, provinsi) untuk infinite scroll select
     * @param {Object} params - Parameter fetch
     * @param {string} params.search - Query pencarian
     * @param {number} params.offset - Offset data untuk pagination
     * @param {number} params.limit - Jumlah item yang akan diambil
     * @returns {Promise<Object>} Promise yang resolve ke objek data
     */
    async fetchProvince({ search, offset, limit }) {
      if (!search && offset === 0 && this.initialLocations.length > 0) {
        return { data: this.initialLocations }
      }
      try {
        const { data } = await this.$http_new.get('/auth/api/v1/partner/regions', {
          params: {
            ...(search ? { search } : {}),
            limit,
            offset,
          },
        })
        const items = data?.data || []
        if (!search && offset === 0) {
          this.initialLocations = items
        }
        return { data: items }
      } catch {
        this.$toast_error('Gagal load data, silahkan coba lagi', 2000)
        return { data: [] }
      }
    },

    /**
     * Memperbarui informasi profil bisnis
     * Memvalidasi form, membuat FormData, dan mengirim PUT request untuk update profil
     * @async
     * @returns {Promise<void>} Promise yang resolve ketika update selesai
     */
    async updateBusiness() {
      this.loadingSubmitBusiness = true
      this.$refs.formBusiness.validate().then(async success => {
        if (success) {
          const formData = new FormData()

          formData.append('user_id', this.userId)
          formData.append('brand_name', this.nameBusiness)
          if (this.sektorBusiness !== null) {
            formData.append('partner_category_name', this.sektorBusiness)
          }
          formData.append('no_hp_business', this.phoneBusiness)
          if (this.cityCode !== null) {
            formData.append('business_location', this.bussinessLocation.values)
          }
          if (this.typeBusiness !== null) {
            formData.append('business_type_id', this.typeBusiness)
          }
          if (this.cityCode !== null) {
            formData.append('city_code', this.cityCode)
          }
          if (this.imageFile !== null) {
            formData.append('business_logo', this.imageFile)
          } else {
            formData.append('business_logo', '')
          }

          this.$http_new.put('/auth/api/v1/partner/profile', formData).then(async () => {
            this.loadingSubmitBusiness = false
            await this.$store.dispatch('dashboard/getProfile')

            const { profile } = this.$store.state.dashboard

            updateProfileKompack({
              business_logo: profile.partner_business_logo,
              brand_name: this.nameBusiness,
              pic_phone: this.phoneBusiness,
              business_location: this.bussinessLocation.values,
              city_code: this.cityCode,
              partner_category_name: this.sektorBusiness,
              business_type_id: this.typeBusiness,
            })
            this.successUpdateBusiness = true

            startCountdown(5000, () => {
              this.$emit('ok')
              this.$bvModal.hide('modal-lengkapi-profil')
            }, secondsLeft => {
              this.countDown = secondsLeft
            })
          }).catch(err => {
            this.loadingSubmitBusiness = false
            throw new Error('Gagal update profile bisnis, silahkan coba lagi')
          })
        } else {
          this.loadingSubmitBusiness = false
        }
      }).catch(err => {
        this.loadingSubmitBusiness = false
        this.$toast_error({ message: err.message })
        this.successUpdateBusiness = false
      })
    },
  },
}
</script>

<style scoped>
img {
  margin: 1rem auto;
}
.success-title {
  margin-top: 2rem;
  color: #000;
  font-size: 2rem;
}
.success-description {
  font-size: 1.1rem;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
